import React, { useState } from 'react';
import { 
  Users, UserCheck, ShieldCheck, Star, 
  CheckCircle2, XCircle, GraduationCap, 
  Heart, Brain, Edit3, Save, X, 
  PlusCircle, ChevronRight, Phone, Mail, Trash2
} from 'lucide-react';

// ✅ CONEXIÓN AL SISTEMA NERVIOSO CENTRAL (Ruta Absoluta)
import { useGlobal } from 'context/GlobalContext';

const GestionMaestros = () => {
  // 1. Extraemos los maestros globales y la función para actualizarlos en tiempo real
  const { maestrosGlobal, setMaestrosGlobal } = useGlobal();

  const [filtro, setFiltro] = useState('Pendientes');
  const [maestroSeleccionado, setMaestroSeleccionado] = useState(null);
  const [editando, setEditando] = useState(false);

  // --- LÓGICA DE GESTIÓN SOBRE DATOS REALES ---
  const manejarCambioAptitud = (campo, valor) => {
    setMaestroSeleccionado({
      ...maestroSeleccionado,
      aptitudes: { ...maestroSeleccionado.aptitudes, [campo]: valor }
    });
  };

  const guardarCambiosFicha = () => {
    setMaestrosGlobal(maestrosGlobal.map(m => m.id === maestroSeleccionado.id ? maestroSeleccionado : m));
    setEditando(false);
    alert("✅ Perfil de Staff actualizado en la base de datos central.");
  };

  const activarMaestro = (id) => {
    setMaestrosGlobal(maestrosGlobal.map(m => m.id === id ? { ...m, estatus: 'Activo' } : m));
    setMaestroSeleccionado(null);
    alert("⭐ Maestro Activado. El staff ya puede iniciar sesión en su portal.");
  };

  const eliminarMaestro = (id) => {
    if(window.confirm("¿CONFIRMAS ELIMINACIÓN PERMANENTE? Se borrarán todos los registros de servicio de este maestro.")) {
      setMaestrosGlobal(maestrosGlobal.filter(m => m.id !== id));
      setMaestroSeleccionado(null);
    }
  };

  const maestrosFiltrados = (maestrosGlobal || []).filter(m => m.estatus === filtro);

  return (
    <div className="w-full max-w-[1400px] mx-auto space-y-10 animate-in fade-in duration-500 pb-24 px-4 text-left font-sans">
      
      {!maestroSeleccionado ? (
        <>
          {/* HEADER Y SELECTOR DE ESTATUS */}
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 border-b-4 border-slate-100 pb-8">
            <div className="space-y-2 text-left">
              <div className="inline-flex items-center gap-2 bg-indigo-600 text-white px-5 py-2 rounded-full shadow-lg">
                <GraduationCap size={18} className="text-indigo-200" />
                <span className="text-[10px] font-black uppercase tracking-widest italic">Recursos Humanos IgleKids</span>
              </div>
              <h2 className="text-4xl md:text-6xl font-black text-slate-900 italic tracking-tighter uppercase leading-none">Staff Docente</h2>
            </div>

            <div className="flex bg-white p-2 rounded-[2.5rem] border-2 border-slate-100 shadow-xl gap-2 overflow-x-auto hide-scrollbar">
              {['Pendientes', 'Activo'].map(e => (
                <button 
                  key={e}
                  onClick={() => setFiltro(e)}
                  className={`px-10 py-4 rounded-[1.8rem] text-[11px] font-black uppercase tracking-widest transition-all shrink-0 ${
                    filtro === e ? 'bg-[#0A2440] text-white shadow-lg' : 'bg-slate-50 text-slate-400 hover:bg-slate-100'
                  }`}
                >
                  {e} {e === 'Pendientes' && maestrosGlobal.filter(m => m.estatus === 'Pendientes').length > 0 && 
                    <span className="ml-2 bg-rose-500 text-white px-2 py-0.5 rounded-full text-[9px] animate-pulse">
                      {maestrosGlobal.filter(m => m.estatus === 'Pendientes').length}
                    </span>
                  }
                </button>
              ))}
            </div>
          </div>

          {/* GRID DE STAFF */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {maestrosFiltrados.length === 0 ? (
              <div className="col-span-full py-24 text-center bg-slate-50 rounded-[4rem] border-4 border-dashed border-slate-200 opacity-40">
                 <Users size={80} strokeWidth={1} className="mx-auto mb-4 text-slate-400" />
                 <p className="font-black uppercase tracking-widest text-slate-500 italic">No hay registros en esta categoría</p>
              </div>
            ) : (
              maestrosFiltrados.map(maestro => (
                <div 
                  key={maestro.id}
                  onClick={() => setMaestroSeleccionado(maestro)}
                  className="bg-white p-10 rounded-[4rem] border-2 border-slate-50 flex items-center justify-between group hover:border-indigo-500 transition-all cursor-pointer shadow-sm hover:shadow-2xl relative overflow-hidden"
                >
                  <div className="flex items-center gap-6">
                    <div className={`w-20 h-20 rounded-[2.2rem] flex items-center justify-center shadow-inner transition-colors ${maestro.estatus === 'Activo' ? 'bg-emerald-50 text-emerald-500' : 'bg-amber-50 text-amber-500'}`}>
                      <UserCheck size={40} />
                    </div>
                    <div className="text-left">
                      <h3 className="text-2xl font-black text-slate-800 tracking-tighter uppercase italic leading-none">{maestro.nombre}</h3>
                      <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-2">ID: {maestro.id.slice(-6).toUpperCase()}</p>
                    </div>
                  </div>
                  <ChevronRight className="text-slate-200 group-hover:text-indigo-500 group-hover:translate-x-2 transition-all" size={32} />
                </div>
              ))
            )}
          </div>
        </>
      ) : (
        /* FICHA TÉCNICA DE MAESTRO */
        <div className="max-w-5xl mx-auto space-y-8 animate-in slide-in-from-right-8 duration-500">
          
          <div className="flex justify-between items-center px-6">
            <button onClick={() => { setMaestroSeleccionado(null); setEditando(false); }} className="text-slate-400 font-black text-xs uppercase tracking-widest flex items-center gap-2 hover:text-rose-500 transition-colors italic">
              <X size={20}/> Cerrar Expediente
            </button>
            <div className="flex gap-4">
              <button onClick={() => eliminarMaestro(maestroSeleccionado.id)} className="p-4 bg-rose-50 text-rose-500 rounded-2xl hover:bg-rose-600 hover:text-white transition-all shadow-sm"><Trash2 size={22}/></button>
              {!editando && (
                <button onClick={() => setEditando(true)} className="bg-indigo-600 text-white px-8 py-4 rounded-2xl text-[11px] font-black uppercase tracking-widest flex items-center gap-3 shadow-xl hover:bg-indigo-700 transition-all border-b-4 border-indigo-800 active:scale-95">
                  <Edit3 size={18}/> Editar Aptitudes
                </button>
              )}
            </div>
          </div>

          <div className="bg-white rounded-[5rem] shadow-2xl border-4 border-slate-50 overflow-hidden relative">
            {/* CARNET HEADER */}
            <div className="bg-[#0A2440] p-14 text-white flex flex-col items-center gap-6 relative overflow-hidden">
              <div className="absolute top-0 right-0 p-10 opacity-5 rotate-12">
                <ShieldCheck size={300} />
              </div>
              <div className="w-32 h-32 bg-white/10 rounded-[3rem] flex items-center justify-center border-4 border-white/20 shadow-2xl backdrop-blur-md">
                <GraduationCap size={64} className="text-amber-400" />
              </div>
              <div className="text-center z-10 space-y-4">
                <h3 className="text-5xl font-black italic tracking-tighter uppercase leading-none">{maestroSeleccionado.nombre}</h3>
                <div className="flex flex-wrap gap-4 justify-center">
                  <span className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-indigo-300 bg-white/5 px-6 py-2.5 rounded-2xl border border-white/10"><Mail size={14}/> {maestroSeleccionado.correo}</span>
                  <span className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-indigo-300 bg-white/5 px-6 py-2.5 rounded-2xl border border-white/10"><Phone size={14}/> {maestroSeleccionado.tel}</span>
                </div>
              </div>
            </div>

            {/* EXPEDIENTE TÉCNICO */}
            <div className="p-12 md:p-20 space-y-16">
              
              <div className="grid md:grid-cols-2 gap-16">
                {/* Perfil Psicológico */}
                <div className="space-y-4 text-left">
                  <div className="flex items-center gap-3 text-indigo-600 ml-4">
                    <Brain size={24} />
                    <label className="text-[11px] font-black uppercase tracking-[0.2em] italic">Perfil de Carácter</label>
                  </div>
                  {editando ? (
                    <textarea 
                      className="w-full p-8 bg-slate-50 rounded-[3rem] border-4 border-transparent focus:border-indigo-500 font-bold text-lg text-slate-700 outline-none h-48 resize-none transition-all shadow-inner italic"
                      value={maestroSeleccionado.aptitudes.perfilPsicologico}
                      onChange={(e) => manejarCambioAptitud('perfilPsicologico', e.target.value)}
                    />
                  ) : (
                    <div className="p-8 bg-slate-50 rounded-[3rem] border-2 border-slate-100 shadow-inner">
                      <p className="text-xl font-bold text-slate-700 italic leading-relaxed text-left">"{maestroSeleccionado.aptitudes.perfilPsicologico}"</p>
                    </div>
                  )}
                </div>

                {/* Experiencia */}
                <div className="space-y-4 text-left">
                  <div className="flex items-center gap-3 text-indigo-600 ml-4">
                    <Heart size={24} />
                    <label className="text-[11px] font-black uppercase tracking-[0.2em] italic">Vínculo con Menores</label>
                  </div>
                  {editando ? (
                    <textarea 
                      className="w-full p-8 bg-slate-50 rounded-[3rem] border-4 border-transparent focus:border-indigo-500 font-bold text-lg text-slate-700 outline-none h-48 resize-none transition-all shadow-inner italic"
                      value={maestroSeleccionado.aptitudes.experienciaNinos}
                      onChange={(e) => manejarCambioAptitud('experienciaNinos', e.target.value)}
                    />
                  ) : (
                    <div className="p-8 bg-slate-50 rounded-[3rem] border-2 border-slate-100 shadow-inner">
                      <p className="text-xl font-bold text-slate-700 italic leading-relaxed text-left">{maestroSeleccionado.aptitudes.experienciaNinos}</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Habilidades */}
              <div className="space-y-6 text-left">
                <div className="flex items-center gap-3 text-amber-500 ml-4">
                  <Star size={24} />
                  <label className="text-[11px] font-black uppercase tracking-[0.2em] italic">Especialidades Validadas</label>
                </div>
                <div className="flex flex-wrap gap-4 p-10 bg-slate-50 rounded-[4rem] border-2 border-slate-100 shadow-inner">
                  {maestroSeleccionado.aptitudes.habilidades.map((h, i) => (
                    <div key={i} className="bg-white px-6 py-4 rounded-[2rem] text-sm font-black text-indigo-600 border-2 border-indigo-100 shadow-sm flex items-center gap-4 group">
                      <span className="italic">{h}</span>
                      {editando && (
                        <button 
                          onClick={() => {
                            const filtradas = maestroSeleccionado.aptitudes.habilidades.filter((_, idx) => idx !== i);
                            manejarCambioAptitud('habilidades', filtradas);
                          }}
                          className="text-rose-400 hover:text-rose-600 transition-colors"
                        >
                          <XCircle size={20} />
                        </button>
                      )}
                    </div>
                  ))}
                  {editando && (
                    <button 
                      onClick={() => {
                        const nueva = prompt("Talento a certificar (Ej. MÚSICA, MANUALIDADES):");
                        if(nueva) manejarCambioAptitud('habilidades', [...maestroSeleccionado.aptitudes.habilidades, nueva.toUpperCase()]);
                      }}
                      className="bg-indigo-600 text-white px-8 py-4 rounded-[2rem] text-xs font-black flex items-center gap-3 hover:bg-emerald-500 active:scale-95 shadow-xl transition-all uppercase tracking-widest"
                    >
                      <PlusCircle size={24}/> Certificar Talento
                    </button>
                  )}
                </div>
              </div>

              {/* ACCIONES FINALES */}
              <div className="pt-10 border-t-4 border-slate-50">
                {editando ? (
                  <button 
                    onClick={guardarCambiosFicha}
                    className="w-full py-8 bg-emerald-500 text-white rounded-[3rem] font-black text-lg uppercase tracking-[0.3em] flex items-center justify-center gap-4 shadow-2xl hover:bg-emerald-600 active:scale-95 transition-all border-b-8 border-emerald-700"
                  >
                    <Save size={32} /> Guardar Cambios en Nube
                  </button>
                ) : (
                  maestroSeleccionado.estatus === 'Pendientes' ? (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <button onClick={() => eliminarMaestro(maestroSeleccionado.id)} className="py-7 bg-rose-50 text-rose-500 rounded-[2.5rem] font-black uppercase text-xs tracking-widest border-2 border-rose-100 hover:bg-rose-500 hover:text-white transition-all">
                        Descartar Perfil
                      </button>
                      <button 
                        onClick={() => activarMaestro(maestroSeleccionado.id)}
                        className="md:col-span-2 py-7 bg-slate-900 text-white rounded-[2.5rem] font-black uppercase text-sm tracking-[0.3em] flex items-center justify-center gap-4 shadow-2xl hover:bg-indigo-600 transition-all border-b-8 border-slate-700 active:scale-95"
                      >
                        <CheckCircle2 size={28} className="text-emerald-400" /> Aprobar y Habilitar Maestro
                      </button>
                    </div>
                  ) : (
                    <div className="bg-emerald-50 p-10 rounded-[4rem] border-4 border-emerald-100 flex items-center justify-center gap-8 shadow-inner">
                      <div className="w-20 h-20 bg-emerald-500 text-white rounded-[2.5rem] flex items-center justify-center shadow-lg">
                        <ShieldCheck size={48} />
                      </div>
                      <div className="text-left">
                        <p className="text-3xl font-black text-emerald-900 uppercase tracking-tighter leading-none italic">Staff Acreditado</p>
                        <p className="text-sm font-bold text-emerald-600 mt-2 uppercase tracking-[0.1em] italic">Este maestro ha superado los protocolos de seguridad de Casa de Fe.</p>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionMaestros;